// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1K8wh","right":"Footer_right__SxqIk","buttons":"Footer_buttons__3QZS7"};